import { createContext } from "react";
import type { User } from "firebase/auth";

// Provided by ProtectedShell with the confirmed authenticated user.
// undefined = default (outside ProtectedShell — LoginPage, ProtectedShell itself).
export const AuthContext = createContext<User | undefined>(undefined);
